import SwiperCore, { Autoplay, Lazy } from 'swiper';
import Swiper from 'swiper';

export function speakersSlider() {
  const $slider = $('.speakers-slider');
  if (!$slider || !$slider.length) return;

  SwiperCore.use([Autoplay, Lazy]);

  new Swiper('.speakers-slider', {
    autoplay: {
      delay: 3000,
    },
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    watchSlidesVisibility: true,
    lazy: {
      loadPrevNext: true,
    },
    preloadImages: false,
  });
}
